module.exports = __webpack_public_path__ + "img/14.43dd1af6.jpg";